import { VueCookieNext } from 'vue-cookie-next'

export default function isLogged({ next, router }) {
  if (VueCookieNext.isCookieAvailable('token')) {
    return router.push({name: 'dashboard'})
  }
  return next()
}
